import {useState, useEffect} from "react";
import useSearchBar from "./useSearchBar";

const useTab = (initialSections) => {
    const [sections, setSections] = useState([])
    const [activeTab, setActiveTab] = useState("")

    const {setFilter} = useSearchBar()

    useEffect(() => {
        let newSections = initialSections

        for (let i = 0; i < newSections.length; i++) {
            newSections[i].value = i
        }
        if (newSections.length > 1) {
            let selectedTab = newSections.filter(s => s.state === true)[0].value
            setFilter(newSections.filter(s => s.state === true)[0].key)
            setActiveTab(selectedTab)
        }
        setSections(initialSections)

    }, [initialSections, sections, setFilter])


    const toggleSection = (key) => {
        let newSections = [...sections]
        // Change state of my prev clicked tab
        let prevTab = sections.filter(s => s.state === true)[0]
        let prevTabData = {...prevTab, state: false}
        let indexPrevTab = sections.findIndex(obj => obj.key === prevTab.key)
        newSections[indexPrevTab].state = prevTabData.state;

        //  Change state of the clicked tab
        let newActiveTab = sections.filter(s => s.key === key)[0]
        let newActiveTabData = {...newActiveTab, state: true}
        let indexActiveTab = sections.findIndex(obj => obj.key === key)
        newSections[indexActiveTab].state = newActiveTabData.state;
        setSections(newSections)
    }

    return {sections, toggleSection, activeTab,}
}

export default useTab